import { render } from "./Roster.vue?vue&type=template&id=ff730624"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ff730624"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff730624', script)) {
    api.reload('ff730624', script)
  }
  
  module.hot.accept("./Roster.vue?vue&type=template&id=ff730624", () => {
    api.rerender('ff730624', render)
  })

}

script.__file = "src/views/Mobile/Roster.vue"

export default script